import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { UtilitiesService } from '../../services/utilities.service';
import { DialogRef } from '../dialog/dialog-ref';

@Component({
    selector: 'app-confirm-modal',
    template: `<div class="kx-modal-header">
                @if (showCancel) {
                  <button aria-label="Close" class="close" type="button" (click)="config && config.cancelFunction && config.cancelFunction == 'hide' ? hideConfirmationModal() : onCancel()"><span aria-hidden="true">×</span></button>
                }
                <h3 class="modal-title">{{title | translate | async}}</h3>
              </div>
              <div class="modal-body">
                <div>{{body | translate | async}}</div>
              </div>
              @if ((type == undefined || type == '') && !config && !enableCstmBtn) {
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" (click)="onCancel()" >{{'Cancel' | translate | async}}</button>
                  <button type="submit" id="myAnchor" class="btn btn-primary" (click)="onConfirm()" >{{'OK' | translate | async}}</button>
                </div>
              }
              @if (config && !enableCstmBtn) {
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" (click)="onCancel()" >{{config.cancel}}</button>
                  <button type="submit" id="myAnchor" class="btn btn-primary" (click)="onConfirm()" >{{config.ok}}</button>
                </div>
              }
              @if (config && enableCstmBtn) {
                <div class="modal-footer">
                  @for (b of config | keyvalue; track b) {
                    <button type="button" class="btn" [class]="{'btn-default': b.key=='cancel', 'btn-primary': b.key!='cancel'}" (click)="onCustomBtnEmit(b.key)" >{{b.value| translate| async}}</button>
                  }
                </div>
              }`,
    standalone: false
})
export class ConfirmModalComponent implements OnInit {
  public active: boolean = false;
  public body: string; enableCstmBtn:boolean=false;
  public title: string;
  public onClose: Subject<boolean>;
  public type: string;
  public config: any = false;
  serVal: any;
  showCancel: boolean;
  closeAfterSuccess: boolean;

  public constructor(
    private _bsModalRef: BsModalRef,
    private dialogRef: DialogRef,
    private utilitiesService: UtilitiesService
  ) {
    this.serVal = this.utilitiesService.documentClickedTarget
      .subscribe(target => {
        this.onClick(target)
      })
  }

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  onClick(event) {
    document.addEventListener("keypress", function (event) {
      if (event.key === "Enter" && event.target && event.target['classList'] && event.target['classList'].contains('modal')) {
        event.preventDefault();
        if(document.getElementById("myAnchor") != null){
          document.getElementById("myAnchor").click();
          var elements = document.querySelectorAll("#myAnchor");
          elements.forEach((ele, index) => {
            ele.setAttribute("disabled", '');
            ele.classList.add("disabled");
          });
          setTimeout(function () {
            elements.forEach((ele, index) => {
              ele.removeAttribute("disabled");
              ele.classList.remove("disabled");
            });
          }, 5000);
        }
      }
    });
  }
  public showConfirmationModal(title: string, body: string, type?, showCancel?,closeAfterSuccess?): void {
    this.title = title;
    this.body = body;
    this.type = type;
    this.active = true;
    this.showCancel = showCancel;
    this.closeAfterSuccess = closeAfterSuccess != undefined ? closeAfterSuccess : false;
  }
  public showConfirmationModalCustom(title: string, body: string, config?, showCancel?,enableCstmBtn:boolean=false): void {
    this.title = title;
    this.body = body;
    this.config = config;
    this.active = true;
    this.showCancel = showCancel;
    this.enableCstmBtn = enableCstmBtn;
  }

  public onConfirm(): void {
    if (document.getElementsByClassName('kx-modal-header').length == 1) {
      document.body.classList.remove('modal-open');
    }
    this.active = false;
    this.onClose.next(true);
    if (!this.closeAfterSuccess)
      this._bsModalRef.hide();
    this.dialogRef.close();
  }

  public onCancel(): void {
    if (document.getElementsByClassName('kx-modal-header').length == 1) {
      document.body.classList.remove('modal-open');
    }
    this.active = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public onCustomBtnEmit(key): void {
    if (document.getElementsByClassName('kx-modal-header').length == 1) {
      document.body.classList.remove('modal-open');
    }
    this.active = false;
    this.onClose.next(key);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.active = false;
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

  ngOnDestroy() {
    if(this.serVal){
      this.serVal.unsubscribe();
    }
    document.removeEventListener("keypress", function (event) {

    });
  }
}